const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان محصول',
    },
    barcode: {
      type: 'string',
      title: 'بارکد',
    },
    weight: {
      type: 'string',
      title: 'وزن',
    },
    num_in_box: {
      type: 'string',
      title: 'تعداد در بسته',
    },
    unit_id: {
      type: 'string',
      title: 'واحد محصول',
    },
    category_id: {
      type: 'string',
      title: 'دسته بندی',
    },
    brand_id: {
      type: 'string',
      title: 'برند',
    },
    introtext: {
      type: 'string',
      title: 'توضیحات',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
  },
});

export default schema;
